import React, { createContext } from "react";
import Form from "~/components/parts/Form";
import Buttons from "./Buttons";
import Confirm from "./Confirm";
import Contact from "./Contact";
import Other from "./Other";
import School from "./School";
import { useApplicationFormHandlers } from "./hooks";

export const ApplicationFormContext = createContext(null);

const ApplicationForm = () => {
  const handlers = useApplicationFormHandlers();
  return (
    <ApplicationFormContext.Provider value={handlers}>
      <Form className="flex flex-col gap-8" onSubmit={handlers.handleSubmit}>
        <Contact />
        <School />
        <Other />
        <Buttons />
        <Confirm />
      </Form>
    </ApplicationFormContext.Provider>
  );
};

export default ApplicationForm;
